import pRetry from 'p-retry';
import type { Options as RetryOptions } from 'p-retry';
import type {
  HttpResponse,
  RequestOptions,
  RequestOptionsFactory,
  CreateHttpClientOptions,
} from '@wix/cli-http-client';
import type { AuthState } from '@wix/cli-auth';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { createHttpClient, isHttpError } from '@wix/cli-http-client';
import { getTestOverrides } from '@wix/cli-test-overrides';

type Options = Pick<CreateHttpClientOptions, 'type'> & {
  authState?: AuthState;
};

export async function httpRequest<T>(
  { type, authState }: Options,
  requestOptions: RequestOptions<T> | RequestOptionsFactory<T>,
  retryOptions?: RetryOptions
): Promise<HttpResponse<T>> {
  const { minRetryTimeout } = getTestOverrides();
  const opts = {
    type,
    getAppToken: authState?.getAccessToken,
    createHeaders: authState?.getRequestHeaders,
  };

  try {
    const requestPromise = retryOptions
      ? pRetry(() => createHttpClient(opts).request(requestOptions), {
          ...retryOptions,
          minTimeout: minRetryTimeout,
        })
      : createHttpClient(opts).request(requestOptions);

    return await requestPromise;
  } catch (e) {
    if (isHttpError(e) && e.response?.status === 403) {
      throw new CliError({
        code: CliErrorCode.PermissionDenied(),
        cause: e,
      });
    }
    throw e;
  }
}
